/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
    SortDirectionToJSONTyped,
} from './SortDirection';

/**
 * 
 * @export
 * @interface CategoryOverviewDtoSortingRequestDto
 */
export interface CategoryOverviewDtoSortingRequestDto {
    /**
     * Sortable fields for CategoryOverviewDto: code, totalOrderCount, totalOrderAmount, description
     * @type {CategoryOverviewDtoSortingRequestDtoSortByEnum}
     * @memberof CategoryOverviewDtoSortingRequestDto
     */
    sortBy?: CategoryOverviewDtoSortingRequestDtoSortByEnum | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof CategoryOverviewDtoSortingRequestDto
     */
    sortDir?: SortDirection;
}


/**
 * @export
 */
export const CategoryOverviewDtoSortingRequestDtoSortByEnum = {
    code: 'code',
    totalOrderCount: 'totalOrderCount',
    totalOrderAmount: 'totalOrderAmount',
    description: 'description'
} as const;
export type CategoryOverviewDtoSortingRequestDtoSortByEnum = typeof CategoryOverviewDtoSortingRequestDtoSortByEnum[keyof typeof CategoryOverviewDtoSortingRequestDtoSortByEnum];


/**
 * Check if a given object implements the CategoryOverviewDtoSortingRequestDto interface.
 */
export function instanceOfCategoryOverviewDtoSortingRequestDto(value: object): value is CategoryOverviewDtoSortingRequestDto {
    return true;
}

export function CategoryOverviewDtoSortingRequestDtoFromJSON(json: any): CategoryOverviewDtoSortingRequestDto {
    return CategoryOverviewDtoSortingRequestDtoFromJSONTyped(json, false);
}

export function CategoryOverviewDtoSortingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryOverviewDtoSortingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDir': json['sortDir'] == null ? undefined : SortDirectionFromJSON(json['sortDir']),
    };
}

export function CategoryOverviewDtoSortingRequestDtoToJSON(json: any): CategoryOverviewDtoSortingRequestDto {
    return CategoryOverviewDtoSortingRequestDtoToJSONTyped(json, false);
}

export function CategoryOverviewDtoSortingRequestDtoToJSONTyped(value?: CategoryOverviewDtoSortingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortBy': value['sortBy'],
        'sortDir': SortDirectionToJSON(value['sortDir']),
    };
}

